/*
 * Edge Landing Page JavaScript
 * Entry point for the Edge product landing page.
 * Uses Edge build system (Vite + Tailwind 4).
 */

import './landing-edge.css';

// Import shared utilities
import '../shared/topbar.js';
import '../shared/coupon.js';
import '../shared/mobile-menu.js';

// Import landing page-specific modules
import '../shared/landing/hero.js';
import '../shared/landing/animations.js';
import '../shared/landing/components.js';

// Landing Edge specific functionality
// Most functionality is handled by imported modules:
// - hero.js: Smooth scroll for CTA buttons
// - animations.js: Fade-in on scroll with [data-fade-in]
// - components.js: Accordions, tabs, tooltips

class LandingEdge {
  constructor() {
    this.init();
  }

  init() {
    // Page-specific initialization can go here
    // Most landing page features are auto-initialized by the imported modules
    this.setupOrganizationsCarousel();
    this.setupDemoTool();
  }

  setupDemoTool() {
    const demoSection = document.getElementById('demo');
    if (!demoSection) return;

    const input = demoSection.querySelector('input[type="url"]');
    const button = demoSection.querySelector('button');

    if (!input || !button) return;

    const handleDemo = () => {
      let url = input.value.trim();

      // Validate URL
      if (!url) {
        input.focus();
        return;
      }

      // Add https:// if no protocol specified
      if (!url.match(/^https?:\/\//i)) {
        url = 'https://' + url;
      }

      // Base64 encode the URL
      const base64Url = btoa(url);

      // Redirect to demo
      window.open(`https://demo.pressidiumedge.com/app/ui/?u=${base64Url}`, '_blank');
    };

    // Handle button click
    button.addEventListener('click', handleDemo);

    // Handle Enter key in input
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        handleDemo();
      }
    });
  }

  setupOrganizationsCarousel() {
    const carousel = document.getElementById('organizations-carousel');
    if (!carousel) return;

    const logoSlots = carousel.querySelectorAll('.logo-slot');

    // Initialize each logo slot with random rotation
    logoSlots.forEach((slot, slotIndex) => {
      const logos = slot.querySelectorAll('.logo-item');
      let currentLogoIndex = 0;

      // Show the first logo initially
      logos[currentLogoIndex].classList.add('active');

      // Function to rotate logos in this slot
      function rotateLogos() {
        // Hide current logo
        logos[currentLogoIndex].classList.remove('active');

        // Move to next logo
        currentLogoIndex = (currentLogoIndex + 1) % logos.length;

        // Show next logo
        logos[currentLogoIndex].classList.add('active');

        // Schedule next rotation with random delay
        scheduleNextRotation();
      }

      // Schedule rotation with random delay between 3-6 seconds
      function scheduleNextRotation() {
        const randomDelay = 3000 + Math.random() * 3000; // 3-6 seconds
        setTimeout(rotateLogos, randomDelay);
      }

      // Start rotation after initial random delay
      const initialDelay = 2000 + Math.random() * 2000 * slotIndex; // Stagger initial rotations
      setTimeout(scheduleNextRotation, initialDelay);
    });
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new LandingEdge();
  console.log('Landing: Edge page loaded (Edge/Vite bundle)');
});
